import React from "react";
// import "../..Pages/CmProfilePage/CmProfilePage.Styles.css";
import '../../Pages/CmProfilePage/CmProfilePage.Styles.css';
import EditProfile from "../../Component/ExpertEditProfile/ExpertEditProfile";
import Layout from '../../NewComponent/LayoutEmail/Layout';

export default function EmailSetting() {
    return (
        <>
            <div style={{ marginBottom: "7%" }}>
                <Layout>
                    <div className="container">
                        <div className="midContainerOpen">
                            <div className="headingTop">
                                <h3>Edit Profile</h3>
                            </div>
                            <EditProfile />
                        </div>
                    </div>
                </Layout>
            </div>
        </>
    )
}